const name = 'SiteAspect'

const functionLibrary = {
    getSiteXForDesktop: (siteWidth, screenWidth) => Math.min(Math.floor((siteWidth - screenWidth) / 2), 0)
}

export {name, functionLibrary}
